module.exports = __webpack_public_path__ + "static/media/logo2.1cc676f8.png";